import {
  fetchPastRecordings,
  postPastRecording,
  deletePastRecording,
} from './api';
import remove from 'lodash/remove';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

//TODO: do we need this file?

export const loadPastRecordings = createAsyncThunk(
  'pastRecordings/load',
  async talentId => await fetchPastRecordings(talentId),
);

export const createPastRecording = createAsyncThunk(
  'pastRecordings/create',
  async ({ talentId, values }) => await postPastRecording(talentId, values),
);

export const removePastRecording = createAsyncThunk(
  'pastRecordings/remove',
  async ({ talentId, recordingId }) =>
    await deletePastRecording(talentId, recordingId),
);

const pastRecordingsSlice = createSlice({
  name: 'pastRecordings',
  initialState: {
    pastRecordings: null,
    createError: false,
    deleteError: false,
  },
  extraReducers: builder => {
    builder
      .addCase(loadPastRecordings.fulfilled, (state, action) => {
        state.pastRecordings = action.payload.data;
      })
      .addCase(createPastRecording.fulfilled, (state, action) => {
        const newRecording = action.payload.data;

        state.pastRecordings = [newRecording, ...state.pastRecordings];
        state.createError = false;
      })
      .addCase(createPastRecording.rejected, (state, _) => {
        state.createError = false;
      })
      .addCase(removePastRecording.fulfilled, (state, action) => {
        const deletedRecordingId = action.meta.arg.recordingId;

        remove(
          state.pastRecordings,
          recording => recording.id === deletedRecordingId,
        );
        state.deleteError = false;
      })
      .addCase(removePastRecording.rejected, (state, _) => {
        state.deleteError = true;
      });
  },
  selectors: {
    getDeleteError: state => state.deleteError,
    getCreateError: state => state.createError,
  },
});

export const reducer = pastRecordingsSlice.reducer;
export const { getDeleteError, getCreateError } = pastRecordingsSlice.selectors;
